import * as React from "react";
export const ChooseFileIcon = (props) => (
  <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.90625 9.08337L8.13425 2.85537C8.45706 2.52571 8.84204 2.26333 9.26691 2.08341C9.69178 1.90349 10.1481 1.8096 10.6095 1.80718C11.0709 1.80476 11.5282 1.89385 11.9549 2.0693C12.3817 2.24474 12.7694 2.50307 13.0956 2.82933C13.4219 3.15558 13.6802 3.54329 13.8557 3.97003C14.0311 4.39677 14.1202 4.85406 14.1178 5.31545C14.1154 5.77684 14.0215 6.23317 13.8415 6.65804C13.6616 7.08291 13.3992 7.46789 13.0696 7.7907L7.25225 13.6067C6.89187 13.9554 6.40888 14.1485 5.90744 14.1444C5.40599 14.1402 4.92625 13.9392 4.57167 13.5846C4.21708 13.23 4.01605 12.7503 4.01191 12.2488C4.00778 11.7474 4.20089 11.2644 4.54958 10.904L10.1309 5.32204"
      stroke="#667085"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
